<template>
  <div class="metroBox" @click="clickAll" v-if="rawData || errorMsg">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/metroIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">地铁信息</div>
        </div>
        <!-- 地铁首末班 -->
        <div
          class="type1"
          v-if="type == 'metroSchedule'"
          :class="{ isExpire: isExpire }"
        >
          <div class="stationNameH1">{{ rawData.stationName }}</div>
          <div
            class="line1"
            v-for="(value, key) in rawData.directions"
            :key="key"
          >
            <div class="label">开往</div>
            <div class="station">{{ value.endStation }}</div>
            <div class="right">
              <div class="timeItem">
                <div class="startSymbol">首</div>
                <div class="time">{{ formatTime(value.startTime) }}</div>
              </div>
              <div class="timeItem">
                <div class="endSymbol">末</div>
                <div class="time">{{ formatTime(value.endTime) }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 地铁列车位置 -->
        <div
          class="type2"
          v-if="type == 'metroLocation'"
          :class="{ isExpire: isExpire }"
        >
          <div
            class="stationBox"
            v-for="(value, key) in rawData.directions"
            :key="key"
          >
            <div class="container">
              <div class="stationInfoBox">
                <div class="stationNameBox">
                  <div class="stationName">{{ value.startStation }}</div>
                  <img
                    class="rightArrowSymbol"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/rightArrowSymbol.png"
                    alt=""
                  />
                  <div class="stationName">{{ value.endStation }}</div>
                </div>
                <div class="stationInfo">
                  <div class="label">当前车站</div>
                  <div class="station">{{ rawData.stationName }}</div>
                  <div class="right">
                    <div class="timeItem">
                      <div class="startSymbol">首</div>
                      <div class="time">{{ formatTime(value.startTime) }}</div>
                    </div>
                    <div class="timeItem">
                      <div class="endSymbol">末</div>
                      <div class="time">{{ formatTime(value.endTime) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="realTimeBox" v-if="value.trips.length > 0">
                <div
                  class="realTimeItem"
                  v-for="(value2, key2) in value.trips"
                  :key="key2"
                >
                  <div class="line1">
                    <span class="time">{{
                      formatTime2(value2.stations[0].arrTime)
                    }}</span>
                    <span class="label">分钟</span>
                  </div>
                  <div class="line2">第{{ key2 + 1 }}班预计到达</div>
                </div>
              </div>
              <div class="realTimeBox2" v-else>
                <img
                  class="icon"
                  src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/noMetroIcon.png"
                  alt=""
                />
                <div class="text">暂无运行车次</div>
              </div>
            </div>
            <div class="border_bottom"></div>
          </div>
          <div class="hintBox">
            <div class="hintTitle">温馨提示：</div>
            <div class="hintContent">
              当前显示运营列车实时位置，数据仅供参考，请以实际运营情况为准。
            </div>
          </div>
        </div>
        <!-- 地铁线路图 -->
        <div
          class="metroLineMap"
          v-if="type == 'metroLine'"
          :class="{ isExpire: isExpire }"
        >
          <div class="metroLineMap_text">下面是地铁线路图</div>
          <div
            class="metroLineMap_image_box"
            @click="clickImg(rawData.imageUrl)"
            :style="{ 'background-image': `url(${rawData.imageUrl})` }"
          ></div>
        </div>
        <!-- 地铁票价 -->
        <div
          class="metroPriceBox"
          v-if="type == 'metroFare'"
          :class="{ isExpire: isExpire }"
        >
          <div class="stationNameBox">
            <div class="stationName">{{ rawData.startStation }}</div>
            <img
              class="rightArrowSymbol"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/rightArrowSymbol.png"
              alt=""
            />
            <div class="stationName">{{ rawData.endStation }}</div>
          </div>
          <div class="priceBox">票价{{ rawData.fare / 100 }}元</div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <!-- 查看更多 -->
        <div
          class="bottomBar"
          :class="{ isExpire: isExpire }"
          v-if="errorMsg != '' || type == 'metroFare'"
          @click="clickMoreBtn"
        >
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { previewImage } from "@/utils/previewImage";
const env = process.env.VUE_APP_ENV;
const config = {
  cxnt: {
    // 地铁线路图
    test: "https://h5-ntgj.test.brightcns.cn/metro/",
    prod: "https://h5-maas.speedits.com/metro/",
  },
};
export default {
  props: ["businessContent"],
  data: function () {
    return {
      timer: null,
      isExpire: false,
      expireTime: null,
      rawData: null,
      type: "",
      errorMsg: "",
    };
  },
  methods: {
    // 转义 首末班时间
    formatTime: function (str) {
      return str.split(":")[0] + ":" + str.split(":")[1];
    },
    // 转义 到站时间
    formatTime2: function (arrivalTimeStr) {
      const now = new Date();
      const [h, m, s] = arrivalTimeStr.split(":").map((x) => parseInt(x, 10));

      if ([h, m, s].some((n) => isNaN(n))) return "时间格式错误";

      const arrival = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        h,
        m,
        s
      );

      const diffMs = arrival - now;
      const diffMin = Math.floor(diffMs / 60000);

      if (diffMs < 0) {
        return "1";
      } else if (diffMin < 1) {
        return "1";
      } else {
        return `${diffMin}`;
      }
    },
    // 放大图片
    clickImg: function (img) {
      if (this.isExpire) {
        return;
      }
      previewImage(img);
    },
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      if (!businessContent.expireTime) {
        return;
      }
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          switch (this.businessContent.type) {
            // 地铁线路图
            case "metroLine":
              this.jumpToMetroLine();
              break;
            case "metroFare":
              this.jumpToMetroFare(null, null);
              break;
            case "metroSchedule":
              this.jumpToMetroSchedule(null);
              break;
            case "metroLocation":
              this.jumpToMetroLocation();
              break;
          }
        }, 1000);
      } else {
        // 未失效
        switch (this.businessContent.type) {
          case "metroSchedule":
            this.jumpToMetroSchedule(
              JSON.parse(this.businessContent.bizReq).lineName
            );
            break;
          case "metroLocation":
            let bizReq = JSON.parse(this.businessContent.bizReq);
            if (bizReq.lineName && bizReq.stationName) {
              this.jumpToMetroLocation(bizReq.lineName, bizReq.stationName);
            } else if (bizReq.lineName) {
              this.jumpToMetroLocation(bizReq.lineName);
            } else {
              this.jumpToMetroLocation();
            }
            break;
        }
      }
    },
    // 点击查看更多
    clickMoreBtn: function () {
      if (this.isExpire) {
        return;
      }
      if (this.errorMsg != "") {
        this.jumpToMetroLine();
      } else {
        switch (this.businessContent.type) {
          // 地铁票价
          case "metroFare":
            this.jumpToMetroFare(
              this.rawData.startStation,
              this.rawData.endStation
            );
            break;
          // 错误
          default:
            this.jumpToMetroLine();
            break;
        }
      }
    },
    // 跳转到地铁线路图
    jumpToMetroLine: function () {
      let url = config[this.businessContent.channel][env];
      url = url + "/#/IndexPage";
      window.location.href = url;
    },
    // 跳转到地铁票价  要么就是首页  要么就是跳到详情页  需要传startStationName和endStationName
    jumpToMetroFare: function (startStationName, endStationName) {
      let url = config[this.businessContent.channel][env];
      if (startStationName && endStationName) {
        url =
          url +
          `#/AiPage?path=FaresPage&startStationName=${startStationName}&endStationName=${endStationName}`;
      } else {
        url = url + `#/FaresPage`;
      }
      window.location.href = url;
    },
    // 跳转到地铁首末班 要么就是跳到首页  要么跳到详情页
    jumpToMetroSchedule: function (lineName) {
      let url = config[this.businessContent.channel][env];
      if (lineName) {
        url = url + `#/AiPage?path=DepartListPage&lineName=${lineName}`;
      } else {
        url = url + `#/DepartListPage`;
      }
      window.location.href = url;
    },
    // 跳转到列车位置   3种情况
    jumpToMetroLocation: function (lineName, stationName) {
      let url = config[this.businessContent.channel][env];
      if (lineName && stationName) {
        url =
          url +
          `#/AiPage?path=TrainStatusPage&stationName=${stationName}&lineName=${lineName}`;
      } else if (lineName) {
        url = url + `#/AiPage?path=TrainStatusPage2&lineName=${lineName}`;
      } else {
        url = url + `#/TrainPositionPage2`;
      }
      window.location.href = url;
    },
  },
  mounted: function () {
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      console.log(this.rawData);
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }
    this.checkIsExpire(this.businessContent);
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./metroBox.scss";
</style>
